module.exports = __webpack_public_path__ + "img/mic15.56b53cda.jpg";